import { ParserAbstraction } from "./parser.abstraction";
import { ParserFunctionType } from "../parser.type";
import { BudgetStoreModel } from "../../../../models/store/budget.store.model";

export class BudgetParser extends ParserAbstraction {
  override getParser(version: number): ParserFunctionType {
    if (!this.isSupportedVersion(version)) {
      throw new Error(`Unsupported Budget parser version ${version}`);
    }

    if (version === 0) {
      return BudgetParser_v0;
    }
    return BudgetParser_v0;
  }

  override getSupportedVersion(): number[] {
    return [0];
  }
}

const BudgetParser_v0 = (BudgetItem: any): any => BudgetItem as BudgetStoreModel;
